import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WeightInput from "../WeightInput";
import { DemographicLimits } from "@/features/HealthCheck/types";

interface Props {
  onChange: (data: any) => void;
  data?: { value?: unknown } | null;
}

export default function QuestionTypeWeight(props: Props) {
  const { t } = useTranslation();

  function onChange(value: string) {
    const isValid =
      Number(value) >= DemographicLimits.MIN_ALLOWED_WEIGHT &&
      Number(value) <= DemographicLimits.MAX_ALLOWED_WEIGHT;
    props.onChange({
      data: { value: value },
      isValid: isValid,
    });
  }

  return (
    <>
      <Stack spacing={2} justifyContent="space-between">
        <Stack spacing={2}>
          <Stack spacing={4}>
            <Typography variant="h3">
              {t("QuestionTypeWeight.title")}
            </Typography>
            <WeightInput
              value={props?.data?.value as string}
              onChange={onChange}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
